var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "input-label", style: _vm.labelStyle },
    [
      _vm.title != ""
        ? _c("span", { staticClass: "title", style: _vm.fontStyle }, [
            _vm._v(_vm._s(_vm.title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inputType === "checkbox" && _vm.needLength
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            staticClass: "msg",
            style: _vm.inputStyle,
            attrs: {
              placeholder: _vm.placeholder,
              maxlength: _vm.maxlength,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.model)
                ? _vm._i(_vm.model, null) > -1
                : _vm.model
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.model,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.model = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.model = $$c
                  }
                },
                _vm.changeInput
              ],
              blur: _vm.leaveInput,
              keyup: _vm.inputMsg,
              keydown: _vm.changeMsg
            }
          })
        : _vm.inputType === "radio" && _vm.needLength
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model,
                  expression: "model"
                }
              ],
              staticClass: "msg",
              style: _vm.inputStyle,
              attrs: {
                placeholder: _vm.placeholder,
                maxlength: _vm.maxlength,
                type: "radio"
              },
              domProps: { checked: _vm._q(_vm.model, null) },
              on: {
                change: [
                  function($event) {
                    _vm.model = null
                  },
                  _vm.changeInput
                ],
                blur: _vm.leaveInput,
                keyup: _vm.inputMsg,
                keydown: _vm.changeMsg
              }
            })
          : _vm.needLength
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "msg",
                style: _vm.inputStyle,
                attrs: {
                  placeholder: _vm.placeholder,
                  maxlength: _vm.maxlength,
                  type: _vm.inputType
                },
                domProps: { value: _vm.model },
                on: {
                  change: _vm.changeInput,
                  blur: _vm.leaveInput,
                  keyup: _vm.inputMsg,
                  keydown: _vm.changeMsg,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.model = $event.target.value
                  }
                }
              })
            : _vm._e(),
      _vm._v(" "),
      _vm.inputType === "checkbox" && !_vm.needLength
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            staticClass: "msg",
            style: _vm.inputStyle,
            attrs: { placeholder: _vm.placeholder, type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.model)
                ? _vm._i(_vm.model, null) > -1
                : _vm.model
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.model,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.model = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.model = $$c
                  }
                },
                _vm.changeInput
              ],
              blur: _vm.leaveInput,
              keyup: _vm.inputMsg,
              keydown: _vm.changeMsg
            }
          })
        : _vm.inputType === "radio" && !_vm.needLength
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model,
                  expression: "model"
                }
              ],
              staticClass: "msg",
              style: _vm.inputStyle,
              attrs: { placeholder: _vm.placeholder, type: "radio" },
              domProps: { checked: _vm._q(_vm.model, null) },
              on: {
                change: [
                  function($event) {
                    _vm.model = null
                  },
                  _vm.changeInput
                ],
                blur: _vm.leaveInput,
                keyup: _vm.inputMsg,
                keydown: _vm.changeMsg
              }
            })
          : !_vm.needLength
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "msg",
                style: _vm.inputStyle,
                attrs: { placeholder: _vm.placeholder, type: _vm.inputType },
                domProps: { value: _vm.model },
                on: {
                  change: _vm.changeInput,
                  blur: _vm.leaveInput,
                  keyup: _vm.inputMsg,
                  keydown: _vm.changeMsg,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.model = $event.target.value
                  }
                }
              })
            : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1795c592", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1795c592","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/input/input.vue
// module id = 519
// module chunks = 0 1